import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedModule } from '../shared.module';
import { FileUploaderComponent } from "./file-uploader.component";
import {FileStatusComponent} from "./file-status/file-status.component";
import {MatIconModule} from "@angular/material/icon";
import {AsyncButtonDirectiveModule} from "../async-button/async-button.module";
import {AppMaterialModule} from "../appMaterial/app-material.module";
import {DragDropModule} from "../drag-drop/drag-drop.module";

@NgModule({
    imports: [
        CommonModule,
        FlexLayoutModule.withConfig({ useColumnBasisZero: false }),
        MatIconModule,
        AsyncButtonDirectiveModule,
        AppMaterialModule,
        DragDropModule
    ],
    declarations: [FileUploaderComponent, FileStatusComponent],
    exports: [FileUploaderComponent, FileStatusComponent]
})
export class FileUploaderModule {}
